import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";
import queryString from "query-string";
import { deviceDetect } from "react-device-detect";
import { createGlobalStyle } from 'styled-components';

import AppRouter from "./containers/AppRouter";
import Head from "./components/Head/Head";
import WordingService from "./services/WordingService";
import ErrorBoundary from "./containers/ErrorBoundary";
import TagService from "./services/TagService";
import Help from "./components/Help/Help";
import { path } from './conf/route.conf';

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    margin: 0;
  }
  
  body {
    display: flex;
    flex-direction: column;
  }
 
  footer {
    margin-top: auto;
  }

  /* force input text to use global font family */
  input {
    font-family: inherit;
  }
`;

class App extends Component {
  constructor(props) {
    super(props);
    const qs = this.getQueryString(props.location);
    this.state = {
      qs,
      device: this.getDevice()
    };
    this.setWordingUseCase(qs);
    this.setWebViewMode();
  }

  /**
   * Get eligibility on mount
   */
  componentDidMount() {
    const { getAccess } = this.props;
    const { qs, device } = this.state;
    getAccess({ qs, device });
  }

  /**
   * Set dictionary and force reset app
   * @param {*} prevProps
   */
  componentDidUpdate(prevProps) {
    const { serviceConf } = this.props;
    if (prevProps.serviceConf !== serviceConf) {
      WordingService.setDictionary(serviceConf.dictionary);
      this.forceUpdate();
    }
  }

  /**
   * Get the query string params in url
   * Split the url without the hashbang ('#!/') when a hash is detected
   * @return {*}
   */
  getQueryString = location => {
    let qs = {};
    if (location.search) {
      qs = queryString.parse(location.search);
    }
    if (location.hash) {
      const hashbang = "#!/";
      const url = location.hash.replace(hashbang, "");
      qs = queryString.parse(url);
    }
    return qs;
  };

  /**
   * Set global wording use case if the feature is enable and detect a specific service param
   * @param qs
   */
  setWordingUseCase = qs => {
    if (
      qs &&
      qs.create === "idme" &&
      window.reactAppEnv.features.firstConnection
    ) {
      WordingService.setDictionary('create');
      this.forceUpdate();
    }
  };

  /**
   * Get the string device type
   * @return {string}
   */
  getDevice = () => {
    const device = deviceDetect();
    if (device.isMobile) {
      TagService.setDataLayer("canal", "Mobile Web");
      return "webphone";
    }
    if (device.isTablet) {
      return "tablet";
    }
    TagService.setDataLayer("canal", "Web");
    return "desktop";
  };

  /**
   * Set the meta attributes when the app is in web view mode
   */
  setWebViewMode = () => {
    const { setWebViewMode } = this.props;

    if (!window.o_confCommon.headerDisplay) {
      const meta = document.createElement("meta");
      meta.setAttribute("http-equiv", "pragma");
      meta.setAttribute("content", "webViewMode:1.0");
      document.getElementsByTagName("head")[0].appendChild(meta);
      setWebViewMode(true);
    }
  };

  render() {
    const { login, webViewFlag, location, serviceConf } = this.props;

    let showHelp = true;
    if (webViewFlag === true || location.pathname === path.CONTACT || location.pathname === path.CONFIRM) {
      showHelp = false;
    }
    
    return (
      <>
        <Container aria-live="polite">
          <ErrorBoundary>
            <GlobalStyle />
            <Head login={login} />
            <AppRouter />
            {showHelp && <Help isFirstConnection={serviceConf.dictionary === 'create'} />}
          </ErrorBoundary>
        </Container>
      </>
    );
  }
}

App.defaultProps = {
  login: null,
  webViewFlag: false,
};

App.propTypes = {
  /** Action to check user availability service access */
  getAccess: PropTypes.func.isRequired,
  /** Action to update the webView Mode */
  setWebViewMode: PropTypes.func.isRequired,
  /** Object router location */
  location: PropTypes.shape().isRequired,
  /** String Orange account login state */
  login: PropTypes.string,
  /** Flag to know if you're in webView mode */
  webViewFlag: PropTypes.bool,
  /** String user service case */
  serviceConf: PropTypes.shape(),
};

export default App;
